<template>
  <div class="row print-machines-load">
    <div class="col">
      <div class="row">
        <div class="col mx-2">
          <form @submit.prevent class="form-inline py-2 justify-content-start">
            <div class="d-flex align-items-center">
              <button
                type="button"
                class="btn btn-back btn-lg"
                @click="$router.push('/settings/print-machines')"
              >
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <h2 class="ml-2">Загузка из шаблонов</h2>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col mx-2 mt-4">
          <ul class="list-unstyled">
            <li
              class="d-flex align-items-center mt-2"
              v-for="printMachine in printMachines"
              :key="printMachine.id"
            >
              <h3
                class="print-machines-load__name mr-4"
                :title="printMachine.name"
              >
                {{ printMachine.name }}
              </h3>
              <button
                v-if="!printMachine.loaded && !printMachine.loading"
                class="btn btn-sm btn-outline-primary px-3"
                @click="uploadMachine(printMachine.id)"
              >
                <i class="fa fa-upload"></i>
              </button>
              <button v-else class="btn btn-sm btn-primary px-3" disabled>
                <i class="fa fa-check" v-if="!printMachine.loading"></i>
                <i class="loader" v-else></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
export default {
  name: 'PrintMachinesLoad',
  data () {
    return {
      printMachines: []
    }
  },
  async created () {
    try {
      const resp = await api.get.defaultPrintMachines()
      this.printMachines = resp.data.data.printMachines
    } catch {
      this.$notify({
        message: 'Произошла ошибка',
        type: 'danger'
      })
    }
  },
  methods: {
    async uploadMachine (id) {
      const printMachineIndex = this.printMachines.findIndex(
        (printMachine) => printMachine.id === id
      )
      const printMachine = {
        ...this.printMachines[printMachineIndex],
        loading: true
      }
      this.printMachines.splice(printMachineIndex, 1, printMachine)
      try {
        await api.get.copyPrintMachine(id)
        const printMachine = {
          ...this.printMachines[printMachineIndex],
          loaded: true
        }
        this.printMachines.splice(printMachineIndex, 1, printMachine)
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      } finally {
        const printMachine = {
          ...this.printMachines[printMachineIndex],
          loading: false
        }
        this.printMachines.splice(printMachineIndex, 1, printMachine)
      }
    }
  }
}
</script>

<style lang="scss">
.print-machines-load {
  &__name {
    width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .loader {
    display: inline-block;
    width: 16px;
    height: 16px;
  }

  .loader:after {
    content: " ";
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-left: -1px;
    border: 3px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: loader 1.2s linear infinite;
  }

  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
